interface CalendarBottomSheetProps {
  visible?: boolean;
  modalData?: any;
  onGoBack?: () => void;
  onTryAnnualPlan?: () => void;
  annualMultitripOption?: any;
}
import {
  Backdrop,
  Bullet,
  ButtonRow,
  Description,
  DragHandle,
  Header,
  Heading,
  HeadingRow,
  Icon,
  ItemText,
  List,
  ListItem,
  Overlay,
  Persuasion,
  Sheet,
  SubHeader,
  TextBtn,
  Title,
} from "./Styles";
import FormattedText from "../../../FormattedText/FormattedText";

export const CalendarBottomSheet = ({
  visible,
  modalData,
  onGoBack,
  onTryAnnualPlan,
  annualMultitripOption,
}: CalendarBottomSheetProps) => {
  if (!visible || !modalData) return null;

  return (
    <Overlay>
      <Backdrop onClick={onGoBack} aria-label="close calendar sheet" />
      <Sheet>
        <DragHandle />

        {modalData?.title ? (
          <Title>
            <FormattedText value={modalData.title} />
          </Title>
        ) : null}

        <HeadingRow>
          {modalData?.heading ? (
            <Heading>
              <FormattedText value={modalData.heading} />
            </Heading>
          ) : (
            <div />
          )}
          {modalData?.icon ? <Icon src={modalData.icon} alt="calendar icon" /> : null}
        </HeadingRow>

        {modalData?.header ? (
          <Header>
            <FormattedText value={modalData.header} />
          </Header>
        ) : null}
        {modalData?.subHeader ? (
          <SubHeader>
            <FormattedText value={modalData.subHeader} />
          </SubHeader>
        ) : null}
        {modalData?.description ? (
          <Description>
            <FormattedText value={modalData.description} />
          </Description>
        ) : null}
        {modalData?.persuasion ? (
          <Persuasion>
            <FormattedText value={modalData.persuasion} />
          </Persuasion>
        ) : null}

        {Array.isArray(modalData?.list) && modalData.list.length > 0 ? (
          <List>
            {modalData.list.map((item: any, index: number) => (
              <ListItem key={`calendar-list-${index}`}>
                <Bullet />
                <ItemText>
                  <FormattedText value={item?.title} />
                </ItemText>
              </ListItem>
            ))}
          </List>
        ) : null}

        {modalData?.secondaryCtaText || modalData?.primaryCtaText ? (
          <ButtonRow>
            {modalData?.secondaryCtaText ? (
              <TextBtn onClick={onGoBack}>
                <FormattedText value={modalData.secondaryCtaText} />
              </TextBtn>
            ) : (
              <span />
            )}
            {modalData?.primaryCtaText ? (
              <TextBtn onClick={onTryAnnualPlan}>
                <FormattedText value={modalData.primaryCtaText} />
              </TextBtn>
            ) : null}
          </ButtonRow>
        ) : null}
      </Sheet>
    </Overlay>
  );
};

